import{ memo } from "react";
import HomeContent from "./homeContent";
const EmployeeHomePage = () =>{
    return (
        <HomeContent />
    );
}

export default memo(EmployeeHomePage);